exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".organisation-table .VueTables__table {\n  min-height: 300px;\n}\n", ""]);

// exports
